import { useState } from "react";

const useLoading = () => {
  const [isLoading, setIsLoading] = useState(false);
  const startLoading = () => setIsLoading(true);
  const stopLoading = () => setIsLoading(false);
  return { startLoading, stopLoading, isLoading };
};

export default useLoading;
